import { Plus } from 'lucide-react'
import type { MaintenanceEvent } from '~/api/types'
import { formatDateTime } from './utils'

/** 평가별 변경 이력 목록과 새 변경 입력 진입점을 표시한다. */
export function ChangeHistoryCard({
    history,
    selectedEventId,
    onSelectEvent,
    onNewChange,
}: {
    history: MaintenanceEvent[] | null
    selectedEventId: string | null
    onSelectEvent(value: string): void
    onNewChange(): void
}) {
    return (
        <section className='border-border bg-card flex min-h-0 flex-1 flex-col rounded-md border p-4'>
            <div className='flex items-center justify-between gap-2'>
                <h2 className='text-foreground text-sm font-semibold'>
                    변경 이력
                </h2>
                <button
                    type='button'
                    onClick={onNewChange}
                    className='text-muted-foreground hover:text-primary rounded-sm p-1'
                    aria-label='새 변경 입력'>
                    <Plus className='size-4' />
                </button>
            </div>
            <div className='mt-3 min-h-0 overflow-y-auto pr-1'>
                {history === null ? (
                    <p className='text-muted-foreground text-sm'>
                        이력을 불러오는 중…
                    </p>
                ) : history.length === 0 ? (
                    <p className='text-muted-foreground text-sm'>
                        아직 변경 이력이 없습니다.
                    </p>
                ) : (
                    <ul className='grid gap-2'>
                        {history.slice(0, 8).map((event) => (
                            <li key={event.id}>
                                <button
                                    type='button'
                                    onClick={() => onSelectEvent(event.id)}
                                    className={`w-full rounded-md border p-3 text-left transition-colors ${
                                        selectedEventId === event.id
                                            ? 'border-primary bg-accent'
                                            : 'border-border hover:border-primary'
                                    }`}>
                                    <p className='text-muted-foreground text-xs'>
                                        {formatDateTime(event.createdAt)}
                                    </p>
                                    <p className='text-foreground mt-1 line-clamp-2 text-sm font-medium'>
                                        {event.changeDescription}
                                    </p>
                                    <p className='text-muted-foreground mt-1 text-xs'>
                                        {event.impact.affected.length}개 항목
                                        검토
                                    </p>
                                </button>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </section>
    )
}
